import React from "react";
import styled from 'styled-components'
import Container from '@material-ui/core/Container';
import {H4, StyledInput, StyledButton, StyledError} from "../../../../component/Typeset";


const StyledLink = styled.div`
  margin: 10px 0;
  cursor: pointer;
  color: white;
  font-size: 0.8rem;
`;

class LoginForm extends React.Component {
  state = {
    email: "",
    password: "",
  };

  handleTextChange = (event, attrName) => {
    const text = event.target.value;
    this.setState({ [attrName]: text });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.props.login(this.state);
  };

  render = () => {
    const {loginError = []} = this.props;

    return (
      <Container maxWidth={'xs'}>
        <div style={{backgroundColor: 'rgba(39, 37, 37, .85)', borderRadius: 8, padding: '30px'}}>
          <H4 style={{textAlign: 'center', marginBottom: 40}}>SIGN IN</H4>
          <form onSubmit={this.handleSubmit}>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Email</div>
              <StyledInput
                type="email"
                value={this.state.email}
                placeholder={'Email'}
                onChange={(e) => this.handleTextChange(e, 'email')}
              />
            </div>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Password</div>
              <StyledInput
                type="password"
                placeholder={'Password'}
                value={this.state.password}
                onChange={(e) => this.handleTextChange(e, 'password')}
              />
              {loginError && loginError.email && <StyledError>{loginError.email}</StyledError>}
              {loginError && loginError.password && <StyledError>{loginError.password}</StyledError>}
              {loginError && loginError.non_field_errors && <StyledError>{loginError.non_field_errors}</StyledError>}
            </div>
            <StyledButton type="submit" style={{marginTop: 15}} disabled={this.props.isLoading}>Sign In</StyledButton>
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 10}}>
              <StyledLink onClick={this.props.resetPassword}>
                Forgot password?
              </StyledLink>
              <StyledLink onClick={this.props.onClose}>
                Create account
              </StyledLink>
            </div>
          </form>
        </div>
      </Container>
    );
  };
}

export default LoginForm;
